import { renderBlockContent } from "../kit/blocks";
import { FileCatalogList } from "../kit/files";
import { Heading } from "../kit/Heading";
import { ImageGallery } from "../kit/images";

export default function SectionOne({ data }) {
  return (<>
    {data.sectionOne.introText ?
      <> <div className="container mx-auto px-5">
        <div className="">
          <Heading data={data.sectionOne.heading} />
          <div>{renderBlockContent(data.sectionOne.introText)}</div>
        </div>
        <div className="flex flex-wrap">
          <div className="w-full md:w-1/2">
            <div>{renderBlockContent(data.sectionOne.text)}</div>
            <div><FileCatalogList catalogs={data.sectionOne.files} /></div>
          </div>
          <div className="w-full md:w-1/2">
            <ImageGallery images={data.sectionOne.images} key="abc" />
          </div>
        </div>
      </div>
      </>
      : <>
        {data?.sectionOne?.heading?.fullwidth ?
          <div className="container mx-auto px-5 ">
            <Heading data={data.sectionOne.heading} />
            <div className="container mx-auto flex  flex-wrap">

              <div className="w-full md:w-1/2">

                {renderBlockContent(data.sectionOne.text)}
                <div><FileCatalogList catalogs={data.sectionOne.files} /></div>
              </div>
              <div className="w-full md:w-1/2">
                <ImageGallery images={data.sectionOne.images} key="abc" />
              </div>
            </div>
          </div> :
          <div className="container mx-auto px-5 flex flex-wrap">
            <div className="w-full md:w-1/2">
              <Heading data={data.sectionOne.heading} />
              <div>{renderBlockContent(data.sectionOne.text)}</div>
              <div><FileCatalogList catalogs={data.sectionOne.files} /></div>
            </div>
            <div className="w-full md:w-1/2">
              <ImageGallery images={data.sectionOne.images} key="abc" />
            </div>
          </div>
        }


      </>}

  </>
  );
}
